import React, { FC } from "react";
import { Controller } from "react-hook-form";

import {
  validateCustomFieldMaxValue,
  validateCustomFieldMinValue,
  validateUniqueCustomField,
} from "../../common/utils/form";
import Text, { TextVariant } from "../../components/Display/Text";
import NumberInput from "../../components/DataInput/NumberInput";
import { FieldControllerPropsBase } from "./Onboarding";

type EnrichedByBoringControllerProps = FieldControllerPropsBase & {
  customFieldValue?: number | string | null;
  timestampCustomFieldValue?: number | string | null;
};

const EnrichedByBoring: FC<EnrichedByBoringControllerProps> = ({
  control,
  errors,
  customFieldValue,
  timestampCustomFieldValue,
  setValue,
}) => {
  return (
    <div className="d-flex flex-column gap-4 align-items-center">
      <Text variant={TextVariant.sm} className="text-center">
        Choose a custom field for us to mark with &quot;Enriched by boring&quot;
        for prospect who&apos;s emails we find for you.
      </Text>
      <div className="w-40">
        <Controller
          name="organizationSettings.enrichedCustomField"
          control={control}
          rules={{
            validate: (value) =>
              validateUniqueCustomField({
                isEnabled: true,
                value: value?.toString() || "",
                otherValues: [
                  customFieldValue?.toString() || "",
                  timestampCustomFieldValue?.toString() || "",
                ],
              }),
            min: validateCustomFieldMinValue({ minValue: 1, isEnabled: true }),
            max: validateCustomFieldMaxValue({
              maxValue: 150,
              isEnabled: true,
            }),
          }}
          render={({ field: { ref, value } }) => {
            // Onboarding is only for Outreach, so value should be a number
            const numericValue = typeof value === 'number' ? value : (typeof value === 'string' ? parseInt(value, 10) || undefined : undefined);
            return (
              <NumberInput
                label="Enriched by"
                inputRef={ref}
                value={numericValue}
                onChange={(value: number) => {
                  setValue("organizationSettings.enrichedCustomField", value);
                }}
                error={!!errors.organizationSettings?.enrichedCustomField}
                helperText={
                  errors.organizationSettings?.enrichedCustomField?.message
                }
              />
            );
          }}
        />
      </div>
    </div>
  );
};

export default EnrichedByBoring;
